import InventoryList from 'partsOld/components/InventoryList';
import { ICompanyPart } from 'partsOld/types';

import { filtersConfig } from './configs';

interface IProps {
  part: Partial<ICompanyPart>;
}

const InventoryTabView = ({ part }: IProps) => {
  return <InventoryList part={part} filtersConfig={filtersConfig} />;
};

export default InventoryTabView;
